<ng-container [ngSwitch]="model">
  <ng-container *ngSwitchCase="ContractEnum.CDI" i18n>CDI</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.CDD" i18n>CDD</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Apprentissage" i18n>Apprentissage</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Stage" i18n>Stage</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Interim" i18n>Mission intérimaire</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Saisonnier" i18n>Saisonnier</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Intermittent" i18n>Intermittent</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Freelance" i18n>Freelance</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.These" i18n>Thèse</ng-container>
  <ng-container *ngSwitchCase="ContractEnum.Professionalisation" i18n>Professionalisation</ng-container>

  <ng-container *ngSwitchDefault>{{ model }}</ng-container>
</ng-container>
